import React, { Component } from "react";
import { trans } from "../../../../helpers/index";
import ApiManager from "../../../../apiManager/index";
import FormMiddlewareError from "../../../Fragments/FormMiddlewareError";
import ErrorModal from "../../../Fragments/ErrorModal";
import { Link } from "react-router-dom";
import config from "../../../../baseConfig";
import Select from "react-select";
import { localStorageGetItem, localStorageSetItem } from "../../../../storage";
import Modal from "../../../Fragments/Modal";

class B2bStepOne extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: false,
      showErrorModal: false,
      successModal: false,
      b2bUserName: "",
      formResponse: "",
      selectedOption:
        this.options()[localStorageGetItem("b2bSelectedType") || 0],
    };

    // Define private properties
    this.componentIsMounted = true;

    // Bind own methods
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleSelectChange(newState) {
    this.setState({
      selectedOption: newState,
    });

    localStorageSetItem("b2bSelectedType", newState.value);
  }

  options() {
    return [
      {
        value: 0,
        label: trans(
          this.props.trans,
          "b2b.forgot_password.select_option_text1"
        ),
      },
      {
        value: 1,
        label: trans(
          this.props.trans,
          "b2b.forgot_password.select_option_text2"
        ),
      },
    ];
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  successModal() {
    if (!this.state.successModal) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "b2b.forgot_password.success.title")}
        description={trans(
          this.props.trans,
          "b2b.forgot_password.success.description"
        )}
        agreeText={trans(this.props.trans, "b2b.forgot_password.success.agree")}
        agreeAction={() => {
          this.props.history.push(config.urlPrefix);
        }}
      />
    );
  }

  reSendData() {
    this.setState({ buttonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        if (!this.componentIsMounted) {
          return;
        }

        this.props.setTokenAction(resolve.data);
        this.sendData();
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData() {
    this.setState({ buttonDisabled: true });

    let type = null;

    if (this.state.selectedOption) {
      type = this.state.selectedOption.value === 0 ? "admin" : "curator";
    }

    ApiManager.postRequest(
      {
        email: this.state.b2bUserName,
        _token: this.props.csrf_token.data,
        type,
      },
      "/b2b/forgot-password"
    ).then(
      (resolve) => {
        if (!this.componentIsMounted) {
          return;
        }

        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          this.setState({
            successModal: true,
          });
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          this.reSendData();
        }
      },
      (reject) => {
        if (!this.componentIsMounted) {
          return;
        }

        this.setState({ showErrorModal: true });
      }
    );
  }

  render() {
    let errorUserNameClass = "",
      errorUserNameBox = "",
      errorTypeClass = "",
      errorTypeBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("email")) {
          errorUserNameClass = " form-error";
          errorUserNameBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.email}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("message")) {
          errorUserNameClass = " form-error";
          errorUserNameBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.message}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("type")) {
          errorTypeClass = " form-error";
          errorTypeBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.type}
            </div>
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError
            message={this.state.formResponse.message}
            trans={this.props.trans}
          />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => {
            event.preventDefault();
            this.sendData();
          }}
        >
          <div className={`form__form-box${errorTypeClass}`}>
            <label className="form__label db fs11" htmlFor="login-type">
              {trans(this.props.trans, "b2b.forgot_password.type_label")}
            </label>
            <div className="form__field-out form__field-out--select-big">
              <Select
                options={this.options()}
                value={this.state.selectedOption}
                onChange={this.handleSelectChange}
                placeholder={trans(
                  this.props.trans,
                  "b2b.forgot_password.select_default_label"
                )}
                noOptionsMessage={() =>
                  trans(
                    this.props.trans,
                    "b2b.forgot_password.select_no_options_message"
                  )
                }
              />
            </div>
            {errorTypeBox}
          </div>

          <div className={`form__form-box${errorUserNameClass}`}>
            <label className="form__label db fs11" htmlFor="email">
              {trans(this.props.trans, "b2b.forgot_password.email_label")}
            </label>
            <div className="form__field-out">
              <input
                className="form__field fs13"
                id="email"
                name="email"
                type="text"
                value={this.state.b2bUserName}
                onChange={(event) => {
                  this.setState({
                    b2bUserName: event.target.value.trim(),
                  });
                }}
              />
            </div>
            {errorUserNameBox}
          </div>

          {errorBox}

          <button
            className={`form__registration-btn btn btn--with-space btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "b2b.forgot_password.button.title")}
          </button>

          <Link
            className="form__submit-btn btn btn--white db fs17 sprite-b tc"
            to={config.urlPrefix}
          >
            {trans(this.props.trans, "b2b.forgot_password.button.cancel")}
          </Link>
        </form>

        {this.errorModal()}
        {this.successModal()}
      </div>
    );
  }
}

export default B2bStepOne;
